module.exports = __webpack_public_path__ + "assets/img/cyhd.d9512068.png";